// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-1dc3b51a] .el-upload-dragger {\n  width: 560px;\n  max-width: 560px;\n}\n", ""]);
// Exports
module.exports = exports;
